export default {
  computed: {
    currentData() {
      const weekday = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      let date = new Date()
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return '<span>'+Y+'</span>' + '年' + '<span>' + M + '</span>' + '月' + '<span>' + D + '</span>' + '日  ' + weekday[date.getDay()]
    }
  }
}
